/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  basic: {
    width: '50%'
  }
});
